import _slicedToArray from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from "react";
export var useDetectAdBlock = function useDetectAdBlock() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      adBlockDetected = _useState2[0],
      setAdBlockDetected = _useState2[1];

  useEffect(function () {
    var url = "https://www3.doubleclick.net";
    fetch(url, {
      method: "HEAD",
      mode: "no-cors",
      cache: "no-store"
    }).catch(function () {
      setAdBlockDetected(true);
    });
  }, []);
  return adBlockDetected;
};